const mobileMenu = () => {
    const wDoc = window.document;
    const items = document.querySelectorAll('.menu-item-has-children');
    items &&
        items.forEach((item) => {
            if (item instanceof HTMLElement) {
                item.addEventListener('click', (event) => {
                    const { target } = event;
                    if (target instanceof HTMLElement) {
                        target.classList.toggle('open');
                    }
                });
            }
        });
    wDoc.addEventListener('click', (event) => {
        var _a;
        const target = event.target;
        const ROLE = (_a = target.dataset) === null || _a === void 0 ? void 0 : _a.role;
        switch (ROLE) {
            case 'open-close-mobile-menu':
                {
                    const headerContentMenu = wDoc.querySelector('.js-header-content-area');
                    target.classList.toggle('clicked');
                    headerContentMenu && headerContentMenu.classList.toggle('opened');
                    wDoc.querySelector('html').classList.toggle('popup-opened');
                }
                break;
            default:
                break;
        }
    });
};
export default mobileMenu;
